import { persist } from "zustand/middleware";

import { InitialUserPortalType } from "../types/global";

const initailStore: InitialUserPortalType = {
  portal: null,
  clearPortalState: () => {},
  setPortalState: () => {},
};

const portalStore = persist(
  (set) => ({
    portal: initailStore.portal,
    setPortalState: (data: string) => set(() => ({ portal: data })),
    clearPortalState: () => set({ auth: initailStore.portal }),
  }),
  {
    name: "portal",
    version: 0.1,
  },
);

export { portalStore };
